export default __webpack_public_path__ + "static/media/logoBackground.59385eb1.jpg";